import { createReducer } from 'reduxsauce'
import Types from './actionTypes'
 
export const INITIAL_STATE = { isloading: false, error: false, user: null, requestId: null }

export const fetchUser = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false };
}
 
export const fetchUserSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, user: action.responseData };
}
 
export const fetchUserFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error };
}

export const updateUser = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false };
}
 
export const updateUserSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, user: action.responseData };
}
 
export const updateUserFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error };
}

export const saveUserDetails = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, user: action.payload };
}

export const saveUser = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: true, error: false, requestId: null };
}
 
export const saveUserSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: false, requestId: action.responseData };
}
 
export const saveUserFailure = (state = INITIAL_STATE, action) => {
  return { ...state, isloading: false, error: true, error_message: action.error, requestId: null };
}

export const HANDLERS = {
	[Types.FETCH_USER]: fetchUser,
  [Types.FETCH_USER_SUCCESS]: fetchUserSuccess,
  [Types.FETCH_USER_FAILURE]: fetchUserFailure,
  [Types.UPDATE_USER]: updateUser,
  [Types.UPDATE_USER_SUCCESS]: updateUserSuccess,
  [Types.UPDATE_USER_FAILURE]: updateUserFailure,
  [Types.SAVE_USER]: saveUser,
  [Types.SAVE_USER_SUCCESS]: saveUserSuccess,
  [Types.SAVE_USER_FAILURE]: saveUserFailure,
  [Types.SAVE_USER_DETAILS]: saveUserDetails,
}
 
export default createReducer(INITIAL_STATE, HANDLERS);
